(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoDeleteController',SSProyectoDeleteController);

    SSProyectoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSProyecto'];

    function SSProyectoDeleteController($uibModalInstance, entity, SSProyecto) {
        var vm = this;

        vm.sSProyecto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        console.log(vm.sSProyecto);

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	console.log(id);
            SSProyecto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
